'use strict';

function expirationInDays(date) {
	const today = new Date().valueOf();

	return Math.ceil(((((date - today) / 1000) / 60) / 60) / 24);
}

export default expirationInDays;
